export default "__VITE_ASSET__6L3c8qYN__"